import React, { useState } from 'react';
import BASE_URL from '../utils/api';

// Pop-up "Adicionar nova pessoa": cadastra a pessoa (nome e custo/hora) sem sair da tela.
// Depois de criar, chama onCriada(pessoa) para a tela recarregar os responsáveis e já selecionar a nova pessoa.
export default function PopupNovaPessoa({ onFechar, onCriada }) {
  const [nome, setNome] = useState('');
  const [custoHora, setCustoHora] = useState('');
  const [salvando, setSalvando] = useState(false);

  const salvar = async () => {
    if (!nome.trim()) {
      alert('O nome é obrigatório.');
      return;
    }
    try {
      setSalvando(true);
      const resposta = await fetch(`${BASE_URL}/Pessoas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nome: nome.trim(), custoHora: custoHora !== '' ? parseFloat(custoHora) || 0 : 0 })
      });
      if (!resposta.ok) throw new Error((await resposta.text()) || `Erro ${resposta.status}`);
      let criada = null;
      try { criada = await resposta.json(); } catch { /* sem corpo */ }
      onCriada && (await onCriada(criada || { nome: nome.trim() }));
      onFechar && onFechar();
    } catch (err) {
      alert('Erro ao criar pessoa: ' + (err.message || err));
    } finally {
      setSalvando(false);
    }
  };

  const campo = { padding: '10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 14 };
  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 95100, padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 440, background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 8px 30px rgba(0,0,0,0.25)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <h3 style={{ margin: 0, color: 'rgb(235, 133, 0)' }}>Adicionar nova pessoa</h3>
          <button type="button" onClick={onFechar} aria-label="Fechar" title="Fechar" style={{ backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: '50%', width: 34, height: 34, padding: 0, fontSize: 18, cursor: 'pointer' }}>×</button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <label style={{ display: 'flex', flexDirection: 'column', fontSize: 13, fontWeight: 600, gap: 6 }}>
            Nome *
            <input autoFocus value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome da pessoa" style={campo} />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontSize: 13, fontWeight: 600, gap: 6 }}>
            Custo por hora (R$)
            <input type="number" min="0" step="0.01" value={custoHora} onChange={(e) => setCustoHora(e.target.value)} placeholder="0,00" style={campo} />
          </label>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 18 }}>
          <button type="button" className="btn-cancelar-forte" onClick={onFechar} style={{ padding: '10px 18px', borderRadius: 6, border: 'none', cursor: 'pointer', fontWeight: 600 }}>Cancelar</button>
          <button type="button" onClick={salvar} disabled={salvando} style={{ padding: '10px 18px', borderRadius: 6, border: 'none', cursor: 'pointer', fontWeight: 700, background: 'rgb(235, 133, 0)', color: '#fff' }}>
            {salvando ? 'Salvando...' : 'Adicionar pessoa'}
          </button>
        </div>
      </div>
    </div>
  );
}
